import React, { useState, useEffect } from 'react'
import mentoring from '../../../BuisnessDashboard/Images/mentoring.svg'
import AggregatorInformation from './AggregatorInformation';
import Overview from './Overview';
import Partner from './Partner';
import Campaign from './Campaign';
import Events from './Events';
import Budget from './Budget';
import AddCampaign from '../AddScreen/AddCampaign';
import AddPartner from '../AddScreen/AddPartner';
import { ChevronLeft } from 'lucide-react'
import { getaggregatorDataByAggregatorIdbyName } from '../../ActionCreator';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import Leads from './Leads';
import moment from 'moment';
import DateFilterSelect from "../../../../../CustomDatePicker/DateFilterSelectold";

export default function Main({ Data, handleBack, commonFilter, handleFilter }) {
    console.log("Data", Data)
    const [overallData, setOverallData] = useState({})
    const [loader, setLoader] = useState(false)
    const [tabs, setTabs] = useState("overview");
    const [customTab, setCustomTab] = useState("")
    const [data, setData] = useState("")
    const [aggregatorBasicData, setAggregatorBasicData] = useState([
    ]);
    const [dateFilterPopup, setDateFilterPopup] = useState({ show: false, from: moment().subtract(6, 'days').format("YYYY-MM-DD"), to: moment(new Date).format("YYYY-MM-DD") })


    useEffect(() => {
        if (
            commonFilter?.fromDate !== dateFilterPopup.from ||
            commonFilter?.toDate !== dateFilterPopup.to
        ) {
            setDateFilterPopup((prev) => ({
                ...prev,
                from: commonFilter.fromDate,
                to: commonFilter.toDate
            }));
        }
        const obj = { start: moment(commonFilter.fromDate).format("DD-MM-YYYY"), end: moment(commonFilter.toDate).format("DD-MM-YYYY") }
        DatApi(obj)

    }, [commonFilter]);

    const handleDateFilterPopup = (type, val) => {
        setDateFilterPopup((prev) => ({ ...prev, [type]: val }))
        const formatted = moment(val).format("YYYY-MM-DD");

        setDateFilterPopup((prev) => {
            if (prev[type] === formatted) return prev;

            return {
                ...prev,
                [type]: formatted
            };
        });

        if (type === "from") {
            if (commonFilter.fromDate !== formatted) {
                handleFilter("fromDate", formatted);
            }
        } else {
            if (commonFilter.toDate !== formatted) {
                handleFilter("toDate", formatted);
            }
        }
    }

    const handleTabs = (type) => {
        setTabs(type)
    }

    const handleCustomTab = (type, data) => {
        setData(data)
        setTimeout(() => {
            setCustomTab(type)
        }, 300)
    }




    const DatApi = (obj) => {
        setLoader(true)
        getaggregatorDataByAggregatorIdbyName(obj?.start, obj?.end, Data?.id, Data?.name, callback => {
            setLoader(false)
            const data = callback?.data?.[0]
            setOverallData(data)
            setAggregatorBasicData([
                { logo: mentoring, text: "Total Leads", value: data?.totalLeads ?? 0, logocolor: "#DCCCF0" },
                { logo: mentoring, text: "No. of Partners", value: data?.partners ?? 0, logocolor: "#F49F2861" },
                { logo: mentoring, text: "Active Campaign", value: data?.activeCampaigns ?? 0, logocolor: "#66ACAF5C" },
                { logo: mentoring, text: "Budget Utilisation", value: data?.budgetUtilization ?? 0, logocolor: "#F374C05C" },
                { logo: mentoring, text: "CRM Mapping Key", value: data?.crmMappingKey ?? "-", logocolor: "#FFBABA" },
                { logo: mentoring, text: "Disburse Count", value: data?.disbursementCount ?? 0, logocolor: "#6776D485" },
                { logo: mentoring, text: "Total Disbursement Amount", value: data?.disbursementAmount ?? 0, logocolor: "#429EE05C" },
                { logo: mentoring, text: "Overall Conversion %", value: data?.overallConversion ?? 0, logocolor: "#EC263A69" },
            ])
        })
    }


    return (
        <>
            {loader ? <Loader /> : ""}
            {console.log("Data", Data)}
            {
                customTab == "" ?
                    <>
                        <div className='OverView-Main-Section min-size-marketing-1800'>
                            <div className='HeadingFilter-Section'>
                                <div>
                                    <h4 style={{ display: 'inline-flex', gap: '5px', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleBack("dashboard", "")}>
                                        <ChevronLeft style={{ width: 'auto' }} />
                                        {overallData?.aggregatorName ?? "Aggregator Name"}
                                    </h4>


                                </div>
                                <div className='topsTabs' style={{ border: 'none' }}>
                                    <div className='rightTabs' style={{ padding: '0' }}>
                                        <button className={`rightSideBtn active`} style={{ background: '#035865', color: '#fff' }} >Export</button>
                                    </div>
                                </div>
                            </div>

                            <div className={`AggregatorStats ${overallData?.status == true ? "active" : "inactive"}`} style={{ marginTop: '20px' }}>
                                <div className='Name-logo'>
                                    <div className='circle-icon' style={{ textAlign: 'center' }}>{overallData?.aggregatorName?.charAt(0) ?? ""}</div>

                                    <div>
                                        <h5>{overallData?.aggregatorName ?? ""}</h5>
                                        <h6>Aggregator ID:{overallData?.aggregatorId ?? ""}</h6>
                                    </div>
                                    <div className='statuschip active'>{console.log("aggregatorBasicData", overallData)}
                                        {overallData?.status == true ? "Active" : "Inactive" ?? ""}
                                    </div>
                                </div>

                                <div className='row' style={{ marginTop: '20px' }}>
                                    {
                                        aggregatorBasicData?.length > 0 ? aggregatorBasicData?.map((Val, id) => {
                                            if (id >= 4) return null
                                            return (
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '20px' }}>
                                                    <div className="cardcustom" style={{ borderRight: id == 3 ? "none" : "1px solid #0C0B1042" }}>
                                                        <div className="logoDiv" style={{ background: Val?.logocolor }}>
                                                            <img src={Val?.logo} width={"100%"} />
                                                        </div>
                                                        <div>
                                                            <h5>{Val?.text}</h5>
                                                            <h6>{Val?.value}</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })
                                            : ""}
                                </div>
                                <hr style={{ border: "0.5px solid #0C0B1042", margin: '20px 5%' }} />
                                <div className="row">
                                    {
                                        aggregatorBasicData?.length > 0 ? aggregatorBasicData?.map((Val, id) => {
                                            if (id <= 3) return null
                                            return (
                                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '0px' }}>
                                                    <div className="cardcustom" style={{ borderRight: id == 7 ? "none" : "1px solid #0C0B1042" }}>
                                                        <div className="logoDiv" style={{ background: Val?.logocolor }}>
                                                            <img src={Val?.logo} width={"100%"} />
                                                        </div>
                                                        <div>
                                                            <h5>{Val?.text}</h5>
                                                            <h6>{Val?.value}</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })
                                            : ""}

                                </div>
                            </div>

                            <div className='HeadingFilter-main-filters' style={{marginTop:'40px'}}>
                                <div className="row">
                                    <div className="col-xs-12" style={{ display: 'flex', gap: '10px' }}>
                                        <DateFilterSelect
                                            value={[new Date(commonFilter.fromDate), new Date(commonFilter.toDate)]}
                                            onChange={(range) => {
                                                handleDateFilterPopup("from", range[0]);
                                                handleDateFilterPopup("to", range[1]);
                                            }}
                                            isFilterCleared={false}
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className='custom-tabss' style={{ marginTop: '40px' }}>
                                <button className={`custombtn ${tabs == "overview" ? "active" : ""}`} onClick={() => handleTabs("overview")}>Overview</button>
                                <button className={`custombtn ${tabs == "aggregatorInfo" ? "active" : ""}`} onClick={() => handleTabs("aggregatorInfo")}>Aggregator Information</button>
                                <button className={`custombtn ${tabs == "partner" ? "active" : ""}`} onClick={() => handleTabs("partner")}>Partners</button>
                                <button className={`custombtn ${tabs == "campaign" ? "active" : ""}`} onClick={() => handleTabs("campaign")}>Campaign</button>
                                {/* <button className={`custombtn ${tabs == "event" ? "active" : ""}`} onClick={() => handleTabs("event")}>Event</button> */}
                                <button className={`custombtn ${tabs == "budget" ? "active" : ""}`} onClick={() => handleTabs("budget")}>Budget</button>
                                <button className={`custombtn ${tabs == "leads" ? "active" : ""}`} onClick={() => handleTabs("leads")}>Leads</button>
                            </div>
                        </div>

                        {
                            tabs == "overview" ? <Overview
                                Data={Data}
                                dateFilterPopup={dateFilterPopup}
                                setDateFilterPopup={setDateFilterPopup}
                                commonFilter={commonFilter}
                                /> : ""

                        }
                        {
                            tabs == "aggregatorInfo" ? <AggregatorInformation
                                Data={Data} 
                                /> : ""

                        }
                        {
                            tabs == "partner" ? <Partner
                                handleCustomTab={handleCustomTab}
                                Data={Data}
                                 dateFilterPopup={dateFilterPopup}
                                setDateFilterPopup={setDateFilterPopup}
                                commonFilter={commonFilter}

                            /> : ""
                        }
                        {
                            tabs == "campaign" ? <Campaign
                                handleCustomTab={handleCustomTab}
                                Data={Data}
                                 dateFilterPopup={dateFilterPopup}
                                setDateFilterPopup={setDateFilterPopup}
                                commonFilter={commonFilter}

                            /> : ""
                        }
                        {
                            tabs == "event" ? <Events
                                Data={Data} /> : ""

                        }
                        {
                            tabs == "budget" ? <Budget
                                Data={Data} 
                                 dateFilterPopup={dateFilterPopup}
                                setDateFilterPopup={setDateFilterPopup}
                                commonFilter={commonFilter}
                                /> : ""

                        }
                        {
                            tabs == "leads" ? <Leads
                                Data={Data} 
                               
                                /> : ""

                        }
                    </>
                    : ""}

            {
                customTab == "AddCampaign" ?
                    <AddCampaign
                        handleCustomTab={handleCustomTab}
                    />
                    : ""}
            {
                customTab == "AddPartner" ?
                    <AddPartner
                        handleCustomTab={handleCustomTab}
                        overallData={overallData} Data={Data}
                    />
                    : ""}


        </>
    )
}
